<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">
          <a @click="$router.go(-1)" style="cursor:pointer"><i class="fas fa-arrow-left"></i></a>
          &nbsp; Laporan Pendapatan
        </h4>
        <div class="action-btn">
          <button class="btn btn-success text-white" @click="exportCSV">
            <i class="fas fa-download"></i> Export CSV
          </button>
        </div>
      </div>

      <div class="card p-3 border bg-white radius-xl mb-3">
        <div class="row align-items-end">
          <div class="col-md-3">
            <label>Dari Tanggal</label>
            <input v-model="from" type="date" class="form-control">
          </div>
          <div class="col-md-3">
            <label>Sampai Tanggal</label>
            <input v-model="to" type="date" class="form-control">
          </div>
          <div class="col-md-3">
            <label>Tipe</label>
            <select v-model="typeFilter" class="form-control">
              <option value="all">Semua</option>
              <option value="orders">Produk / Order</option>
              <option value="donations">Donasi</option>
              <option value="courses">Kursus</option>
            </select>
          </div>
          <div class="col-md-3">
            <button class="btn btn-primary btn-block" @click="load">
              <i class="fas fa-search"></i> Tampilkan
            </button>
          </div>
        </div>
      </div>

      <div v-if="summary" class="row mb-3">
        <div class="col-md-3"><div class="card p-3 border"><small>Total Transaksi</small><h4>{{ summary.total_transactions || summary.total_orders }}</h4></div></div>
        <div class="col-md-3"><div class="card p-3 border"><small>Transaksi Paid</small><h4 class="text-success">{{ summary.paid_transactions || summary.paid_orders }}</h4></div></div>
        <div class="col-md-3"><div class="card p-3 border"><small>Total Pendapatan</small><h4 class="text-primary">{{ formatRupiah(summary.total_revenue) }}</h4></div></div>
        <div class="col-md-3"><div class="card p-3 border"><small>Saldo Net (after fee)</small><h4 class="text-success">{{ formatRupiah(summary.total_shop_owner) }}</h4></div></div>
      </div>

      <div class="card p-3 border bg-white radius-xl">
        <div v-if="isLoading" class="text-center"><div class="spinner-border"></div></div>
        <div v-else-if="transactions.length === 0" class="text-center text-muted p-4">Tidak ada transaksi pada periode ini.</div>
        <table v-else class="table table-sm">
          <thead>
            <tr>
              <th>Tipe</th>
              <th>Tanggal</th><th>Invoice</th><th>Customer</th>
              <th>Total</th><th>Fee</th><th>Net</th><th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in transactions" :key="o.type + '-' + o.id">
              <td><span class="badge" :class="typeBadge(o.type)">{{ typeLabel(o.type) }}</span></td>
              <td><small>{{ formatTime(o.created_at) }}</small></td>
              <td><small><code>{{ o.invoice_number || o.order_id || o.donation_number }}</code></small></td>
              <td>{{ o.customer_name || o.donor_name || '-' }}<br><small class="text-muted">{{ o.customer_phone || o.donor_phone }}</small></td>
              <td>{{ formatRupiah(o.total_amount || o.amount) }}</td>
              <td><small>{{ formatRupiah(o.starsender_fee) }}</small></td>
              <td><b>{{ formatRupiah(o.shop_owner_amount) }}</b></td>
              <td>
                <span class="badge" :class="paymentBadge(o.payment_status)">{{ o.payment_status }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  data() {
    const today = moment().format('YYYY-MM-DD');
    const lastMonth = moment().subtract(30, 'days').format('YYYY-MM-DD');
    return {
      shopId: null,
      from: lastMonth,
      to: today,
      typeFilter: 'all',
      orders: [],
      donations: [],
      enrollments: [],
      summary: null,
      isLoading: false,
    };
  },
  computed: {
    transactions() {
      const orderRows = this.orders.map(o => ({ ...o, type: 'order' }));
      const donationRows = this.donations.map(d => ({
        ...d,
        type: 'donation',
        customer_name: d.is_anonymous ? 'Anonim' : (d.donor_name || 'Donatur'),
        customer_phone: d.donor_phone,
        total_amount: d.amount,
      }));
      const enrollmentRows = this.enrollments.map(e => ({
        ...e,
        type: 'course',
        customer_name: e.student_name || 'Siswa',
        customer_phone: e.student_phone,
        total_amount: e.amount,
        invoice_number: e.invoice_number || e.enrollment_number,
      }));
      const merged = [...orderRows, ...donationRows, ...enrollmentRows];
      merged.sort((a, b) => (b.created_at || 0) - (a.created_at || 0));
      return merged;
    },
  },
  mounted() {
    this.shopId = this.$route.params.id;
    this.load();
  },
  methods: {
    async load() {
      this.isLoading = true;
      try {
        const r = await axios.get('shops/' + this.shopId + '/report', {
          params: { from: this.from, to: this.to, type: this.typeFilter },
        });
        this.orders = r.data.data.orders || [];
        this.donations = r.data.data.donations || [];
        this.enrollments = r.data.data.enrollments || [];
        this.summary = r.data.data.summary;
      } catch (e) { this.$toast.error('Gagal load report'); }
      this.isLoading = false;
    },
    async exportCSV() {
      try {
        const r = await axios.get('shops/' + this.shopId + '/report', {
          params: { export: 'csv', from: this.from, to: this.to, type: this.typeFilter },
          responseType: 'blob',
        });
        const blob = new Blob([r.data], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `report-${this.from}-to-${this.to}.csv`;
        link.click();
      } catch (e) { this.$toast.error('Gagal export'); }
    },
    formatRupiah(v) { return 'Rp ' + (v || 0).toLocaleString('id-ID'); },
    formatTime(t) { return t ? moment(parseInt(t)).format('DD MMM HH:mm') : '-'; },
    paymentBadge(s) {
      return { 'badge-warning': s === 'pending', 'badge-success': s === 'paid', 'badge-danger': s === 'failed' || s === 'expired' };
    },
    typeLabel(t) {
      return { order: 'Order', donation: 'Donasi', course: 'Kursus' }[t] || t;
    },
    typeBadge(t) {
      return { donation: 'badge-success', course: 'badge-info', order: 'badge-primary' }[t] || 'badge-secondary';
    },
  },
};
</script>
